import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import FooterPanel from './FooterPanel';
import HeaderPanel from './HeaderPanel';
import inputs from './form.json';
import { logInUser } from 'redux/actions';

const RecognizeEmailLogin = ({ changeEv }) => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.sign);
    const handleSaveUserData = (data) => {
        dispatch(logInUser(data));
    };
    return loading ? (
        <div className="sign__skeleton">
            <Skeleton height="40px" count={5} />
        </div>
    ) : (
        <Form
            className="form-outline sign--form"
            type="login"
            inputs={inputs.login}
            data={user || []}
            title="Witaj ponownie!"
            handleSubmitEv={handleSaveUserData}
            submitTitle="Zaloguj"
            formHeader={<HeaderPanel>Witaj ponownie!</HeaderPanel>}
            formContent={`<p>Na ten adres e-mail jest już założone konto. <span>Zaloguj się i przyspiesz zakupy!</span></p>`}
            formFooter={<FooterPanel changeEv={() => changeEv('forgotPassword')}>Przypomnienie hasła</FooterPanel>}
        />
    );
};

RecognizeEmailLogin.propTypes = {
    changeEv: PropTypes.func.isRequired,
};

export default RecognizeEmailLogin;
